import { render } from "./RouteNew.vue?vue&type=template&id=7f288e60&scoped=true&ts=true"
import script from "./RouteNew.vue?vue&type=script&lang=ts"
export * from "./RouteNew.vue?vue&type=script&lang=ts"

import "./RouteNew.vue?vue&type=style&index=0&id=7f288e60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f288e60"]])

export default __exports__